// The REACT_APP_* overrides below exist for local validation runs against
// staging data and Stripe test mode (see .env.local.example and
// docs/addon-renewal-validation.md). Unset, every value is production's.
export const constants = {
    environment: 'production',
    version: '1.0',
    apiUrl: process.env.REACT_APP_API_URL || 'https://api.allcal.com',
    dashboardBaseUrl: process.env.REACT_APP_DASHBOARD_BASE_URL || 'https://api.dashboard.allcal.com',
    ticketsBaseUrl: 'https://api.tickets.allcal.com',
    ticketsBaseUrlAlt: 'https://purchase.tickets.allcal.com',
    appBaseUrl: 'https://app.allcal.com',
    templatesBaseUrl: 'http://templates.allcal.com',
    templatesBaseUrlHttps: 'https://templates.allcal.com',
    localhost: 'http://localhost:1338',
    myAccountBaseUrl: process.env.REACT_APP_MY_ACCOUNT_BASE_URL || 'https://myaccount.tanglewoodresort.com',
    selectedOrg: process.env.REACT_APP_SELECTED_ORG || '61305030decd490c26247806',
    selectedCalendar: '6140c463c1e051143a7d12b8',
    regNameDict: {
        GOLF: "Full Golf Membership",
        SOCIAL: "Social Membership",
        GOLF_ADD_ON: "Golf Add-on Membership",
        SOCIAL_ADD_ON: "Social Add-on Membership"
    },
    initiation_fee: {
        golf: '$3000 (one time)',
        social: '$1000 (one time)'
    },
    golfAddOnUrl: 'https://register.tanglewoodresort.com/#/?type=add-ons&regId='+ process.env.REACT_APP_GOLF_ADD_ON_REG_ID,
    socialAddOnUrl: 'https://register.tanglewoodresort.com/#/?type=add-ons&regId='+ process.env.REACT_APP_SOCIAL_ADD_ON_REG_ID,
    golfAddOnRegId: process.env.REACT_APP_GOLF_ADD_ON_REG_ID,
    socialAddOnRegId: process.env.REACT_APP_SOCIAL_ADD_ON_REG_ID,
    SENDGRID_INVITE_ADD_ON_TEMPLATE: process.env.REACT_APP_SENDGRID_INVITE_ADD_ON_TEMPLATE,
    SENDGRID_WELCOME_TEMPLATE: process.env.REACT_APP_SENDGRID_WELCOME_TEMPLATE,
    DOCUSIGN_CLIENT_USER_ID: process.env.REACT_APP_DOCUSIGN_CLIENT_USER_ID,
    // New-member signup (master) templates
    DOCUSIGN_TEMPLATE_ID: process.env.REACT_APP_DOCUSIGN_TEMPLATE_ID,
    DOCUSIGN_TEMPLATE_ID_ADD_ONS: process.env.REACT_APP_DOCUSIGN_TEMPLATE_ID_ADD_ONS,
    // Renewal (stage) templates
    DOCUSIGN_TEMPLATE_ID_RENEW: process.env.REACT_APP_DOCUSIGN_TEMPLATE_ID_RENEW,
    DOCUSIGN_TEMPLATE_ID_ADDON: process.env.REACT_APP_DOCUSIGN_TEMPLATE_ID_ADDON
};
